import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/hearing';

const initialState = fromJS({
  data: [],
  state: null,
  stateCreate: null,
  stateUpdate: null,
  stateDelete: null,
  stateNotice: {},
});

const HearingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.HEARINGS_FETCH_START: {
      return state.set('state', fetchingState.FETCHING);
    }
    case actions.HEARINGS_FETCH_ERROR: {
      return state.set('state', fetchingState.ERROR);
    }
    case actions.HEARINGS_FETCH_SUCCESS: {
      return state
        .set('state', fetchingState.LOADED)
        .set('data', fromJS(_.get(action, 'data.results', [])));
    }
    case actions.CREATE_HEARING_START: {
      return state.set('stateCreate', fetchingState.FETCHING);
    }
    case actions.UPDATE_HEARING_START: {
      return state.set('stateUpdate', fetchingState.FETCHING);
    }
    case actions.DELETE_HEARING_START: {
      return state.set('stateDelete', fetchingState.FETCHING);
    }
    case actions.CREATE_HEARING_SUCCESS: {
      return state.set('stateCreate', fetchingState.LOADED);
    }
    case actions.UPDATE_HEARING_SUCCESS: {
      return state.set('stateUpdate', fetchingState.LOADED);
    }
    case actions.DELETE_HEARING_SUCCESS: {
      const { taxingUnitHearingID } = action.payload;
      return state.set('stateDelete', fetchingState.LOADED).set(
        'data',
        fromJS(
          state
            .get('data')
            .toJS()
            .filter(
              hearing => hearing.taxingUnitHearingID !== taxingUnitHearingID,
            ),
        ),
      );
    }
    case actions.CREATE_HEARING_ERROR: {
      return state.set('stateCreate', fetchingState.ERROR);
    }
    case actions.UPDATE_HEARING_ERROR: {
      return state.set('stateUpdate', fetchingState.ERROR);
    }
    case actions.DELETE_HEARING_ERROR: {
      return state.set('stateDelete', fetchingState.ERROR);
    }

    case actions.CREATE_HEARING_NOTICE_START:
    case actions.DELETE_HEARING_NOTICE_START:
    case actions.GET_HEARING_NOTICE_START:
      return state.setIn(
        ['stateNotice', action.taxingUnitHearingID],
        fetchingState.FETCHING,
      );
    case actions.CREATE_HEARING_NOTICE_SUCCESS:
      let { taxingUnitHearingID } = action;
      return state
        .setIn(['stateNotice', taxingUnitHearingID], fetchingState.LOADED)
        .set(
          'data',
          fromJS(
            state
              .get('data')
              .toJS()
              .map(hearing =>
                hearing.taxingUnitHearingID === taxingUnitHearingID
                  ? action.data.results[0]
                  : hearing,
              ),
          ),
        );
    case actions.CREATE_HEARING_NOTICE_ERROR:
    case actions.DELETE_HEARING_NOTICE_ERROR:
    case actions.GET_HEARING_NOTICE_ERROR:
      return state.setIn(
        ['stateNotice', action.taxingUnitHearingID],
        fetchingState.ERROR,
      );
    case actions.DELETE_HEARING_NOTICE_SUCCESS:
      ({ taxingUnitHearingID } = action);
      return state
        .setIn(['stateNotice', taxingUnitHearingID], fetchingState.LOADED)
        .set(
          'data',
          fromJS(
            state
              .get('data')
              .toJS()
              .map(hearing =>
                hearing.taxingUnitHearingID === taxingUnitHearingID
                  ? {
                      ...hearing,
                      hearingNoticesS3ID: null,
                    }
                  : hearing,
              ),
          ),
        );
    default: {
      return state;
    }
  }
};

export default HearingReducer;
